import { mutationOptions, queryOptions } from '@tanstack/react-query';

import { client, HttpException, type components } from '@/libs/openapi';
import { articleQueries } from '@/resources/article/article.api';
import { queryNamespace } from '@/utils/query-namespace.util';

export const profileQueries = queryNamespace('profile', {
  get: queryOptions({
    queryKey: [],
    queryFn: ({ signal }) => client
      .GET('/api/v1/profile', { signal })
      .then(({ data, error }) => {
        if (error) {
          throw new HttpException();
        }

        return data;
      }),
    staleTime: Infinity,
    retry: false,
  }),
});

export const profileMutations = queryNamespace('profile', {
  create: mutationOptions({
    mutationFn: (data: components["schemas"]["UserProfileCreate"]) => client
      .POST('/api/v1/profile', { body: data })
      .then(({ error, response }) => {
        if (error) {
          throw new HttpException({ message: typeof error.detail === 'string' ? error.detail : error.detail?.map(item => item.msg).join(', '), response });
        }
      }),
    onSuccess: (_data, _variables, _onMutateResult, context) => {
      context.client.invalidateQueries({ queryKey: profileQueries.get.queryKey });
      context.client.invalidateQueries({ queryKey: articleQueries.all.queryKey });
    },
  }),
  update: mutationOptions({
    mutationFn: (data: components["schemas"]["UserProfileUpdate"]) => client
      .PUT('/api/v1/profile', { body: data })
      .then(({ data, error, response }) => {
        if (error) {
          throw new HttpException({ message: typeof error.detail === 'string' ? error.detail : error.detail?.map(item => item.msg).join(', '), response });
        }

        return data;
      }),
    onSuccess: (_data, _variables, _onMutateResult, context) => {
      context.client.invalidateQueries({ queryKey: profileQueries.get.queryKey });
      context.client.invalidateQueries({ queryKey: articleQueries.all.queryKey });
    },
  }),
});
